<template>
    <div
        class="estimation-box"
        v-if="estimation">
        <p class="title">{{ $t("our_estimation") }} {{ estimation.propertyType.toLocaleString() }}</p>

        <h1 class="main-price">€{{ estimation.main.toLocaleString() }}</h1>

        <div class="price-row">

            <!-- Lowest price (arrow on right) -->
            <div class="price-item lowest">
                <div class="text-group">
                    <p class="label">{{ $t("lowest_price") }}</p>
                    <p class="value">€{{ estimation.lowest.toLocaleString() }}</p>
                </div>

                <img
                    class="arrow-icon"
                    :src="downArrow"
                    alt="down arrow">
            </div>

            <!-- Highest price (arrow on left) -->
            <div class="price-item highest">
                <img
                    class="arrow-icon"
                    :src="upArrow"
                    alt="up arrow">

                <div class="text-group">
                    <p class="label">{{ $t("highest_price") }}</p>
                    <p class="value">€{{ estimation.highest.toLocaleString() }}</p>
                </div>
            </div>

        </div>

        <div class="accuracy">
            <div class="dots">
                <span
                    v-for="n in 5"
                    :key="n"
                    class="dot"
                    :class="{ active: n <= estimation.accuracy }"></span>
            </div>
            <p class="accuracy-text">{{ accuracyLabel }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PriceEstimation",

    data: function() {
        return {
            estimation: {
                propertyType: "apartament",
                main: 875000,
                lowest: 795000,
                highest: 935000,
                accuracy: 1 // 1–5
            },

            downArrow: require("@/assets/images/icons/basicInfo/arrow-down.svg"),
            upArrow: require("@/assets/images/icons/basicInfo/arrow-up.svg")
        };
    },

    computed: {
        accuracyLabel: function() {
            const labels = {
                1: "Low accuracy",
                2: "Medium accuracy",
                3: "Acceptable accuracy",
                4: "Good accuracy",
                5: "Excellent accuracy"
            };
            return labels[this.estimation.accuracy] || "Unknown";
        }
    }
};
</script>
